import React from "react";
import styles from "./styles.module.css";
import logo from "../../images/logoBrancoPrincipal.png";

import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import { GridLoader } from "react-spinners";
import { Link } from "@mui/material";

const PageNotFound = () => {
  const navigate = useNavigate();
  
  const navigateBack = () => {
    navigate("/dashboard");
  }

  return (
    <Box className={styles.background}
    >
      <Grid
        container
        spacing={0}
        direction="column"
        zIndex="0"
        position="relative"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item xs={3}>
        <GridLoader
          color="#FFFFFF"
          loading={true}
          size={25}
          aria-label="Loading Spinner"
          data-testid="loader"
        >
        </GridLoader>
        </Grid>
        <Typography sx={{
          color: "#ffffff",
          fontWeight: "bold",
          fontSize: 50,
        }}>
          404
        </Typography>
        <Typography sx={{
          color: "#ffffff",
          fontWeight: "bold",
          fontSize: 25
        }}>
          Página Não Encontrada
        </Typography>
        <Link 
          component="button"
          onClick={navigateBack}
          sx={{
            marginTop: "1"
          }}>
          <img src={logo} className={styles.logoMenu} alt="Logo"></img>
        </Link>
      </Grid>
    </Box>
  );
};

export default PageNotFound;
